module.exports = __webpack_public_path__ + "img/instagram-active.dff87ac.png";